import dataHelper from '../services/data-helper.js';

export const types = {
  CHANGE_MODE: 'CHANGE_MODE',
  SEARCH_START: 'SEARCH_START',
  BICS_RECEIVED: 'BICS_RECEIVED',
  BROWSE_START: 'BROWSE_START',
  BROWSE_PARAMS_RECEIVED: 'BROWSE_PARAMS_RECEIVED',
  BICS_BROWSE_RECEIVED: 'BICS_BROWSE_RECEIVED',
  SELECT_START: 'SELECT_START',
  BICS_SELECTED_RECEIVED: 'BICS_SELECTED_RECEIVED',
  BICS_SELECTED_INIT: 'BICS_SELECTED_INIT',
  BIC_ALTERNATE_START: 'BIC_ALTERNATE_START',
  BIC_ALTERNATE_RECEIVED: 'BIC_ALTERNATE_RECEIVED',
  BIC_ALTERNATE_CLEAR: 'BIC_ALTERNATE_CLEAR',
  INDUSTRIES_FETCH: 'INDUSTRIES_FETCH',
  INDUSTRIES_RECEIVED: 'INDUSTRIES_RECEIVED',
  SECTORS_FETCH: 'SECTORS_FETCH',
  SECTORS_RECEIVED: 'SECTORS_RECEIVED',
  SECTORS_RESET: 'SECTORS_RESET',
  CATEGORY_UPDATE: 'CATEGORY_UPDATE',
  CATEGORIES_FETCH: 'CATEGORIES_FETCH',
  CATEGORIES_RECEIVED: 'CATEGORIES_RECEIVED',
  CATEGORIES_RESET: 'CATEGORIES_RESET',
  INDUSTRIES_SECTORS_FETCH: 'INDUSTRIES_SECTORS_FETCH',       // for browse/industry/:industry
  INDUSTRIES_SECTORS_RECEIVED: 'INDUSTRIES_SECTORS_RECEIVED', // for browse/industry/:industry
  SECTOR_FETCH: 'SECTOR_FETCH', // for browse/division/:division
  SECTOR_RECEIVED: 'SECTOR_RECEIVED', // for browse/division/:division
  INDUSTRIES_SECTORS_CATEGORIES_RECEIVED: 'INDUSTRIES_SECTORS_CATEGORIES_RECEIVED', // for browse/division/:division
  API_ERROR: 'API_ERROR',
  ADD_TO_WATCHLIST: 'ADD_TO_WATCHLIST',
  REMOVE_FROM_WATCHLIST: 'REMOVE_FROM_WATCHLIST',
  CLEAR_WATCHLIST: 'CLEAR_WATCHLIST',
  TOGGLE_BICS_HELP: 'TOGGLE_BICS_HELP',
  SET_SHOW_SELECTED: 'SET_SHOW_SELECTED',
  SET_DISPLAY_LIST: 'SET_DISPLAY_LIST',
};

export default {
  [types.CHANGE_MODE] (state, payload) {
    for (var key of Object.keys(payload)) {
      state[key] = payload[key];
    }
  },
  [types.SEARCH_START] (state, payload) {
    state.mode = 'search';
    state.term = payload.term;
    state.loading = true;
    state.bics = [];
  },
  [types.BICS_RECEIVED] (state, payload) {
    state.bics = payload.bics.slice(); // create clone of the array, doesn't pass the reference 
    state.helpForSearchTerm = payload.helpForSearchTerm;
    state.loading = false;
    state.showSelected = false;
  },
  [types.INDUSTRIES_FETCH] (state) {
    state.industryLoading = true;
    state.industryOptions = [];
    state.sectorOptions = [];
    state.categoryOptions = [];
  },
  [types.INDUSTRIES_RECEIVED] (state, payload) {
    state.industryLoading = false;
    state.industryOptions = payload.slice();
  },
  [types.SECTORS_FETCH] (state, payload) {
    state.industry = payload.industry;
    state.sectorLoading = true;
    state.sectorOptions = [];
    state.categoryOptions = [];
  },
  [types.SECTORS_RECEIVED] (state, payload) {
    state.sectorLoading = false;
    state.sectorOptions = payload.slice();
  },
  [types.SECTORS_RESET] (state) {
    state.sector = null;
    state.sectorLoading = false;
    state.sectorOptions = [];
  },
  [types.CATEGORIES_FETCH] (state, payload) {
    state.sector = payload.sector;
    state.categoryLoading = true;
    state.categoryOptions = [];
  },
  [types.CATEGORIES_RECEIVED] (state, payload) {
    state.categoryLoading = false;
    state.categoryOptions = payload.slice();
  },
  [types.CATEGORY_UPDATE] (state, payload) {
    state.category = payload.category;
  },
  [types.CATEGORIES_RESET] (state) {
    state.category = null;
    state.categoryLoading = false;
    state.categoryOptions = [];
  },
  // for route "browse/industry/:industry" - get list of industries + list of sectors for :industry
  [types.INDUSTRIES_SECTORS_FETCH] (state, payload) {
    for (var attr in payload) {
      state[attr] = payload[attr];
    }
    state.mode = 'browse';
    state.showSelected = false;
    state.industry = payload.industry;
    state.industryLoading = true;
    state.sectorLoading = true;
    state.alternateBic = null;
    state.alternateBicSource = null;
    state.industryOptions = [];
    state.sectorOptions = [];
    state.categoryOptions = [];
    state.category = null;
    state.bics = [];
  },
  [types.INDUSTRIES_SECTORS_RECEIVED] (state, payload) {
    state.industryOptions = payload.industryOptions.slice();
    state.sectorOptions = payload.sectorOptions.slice();
    state.industryLoading = false;
    state.sectorLoading = false;
  },
  // for route "browse/division/:division"
  // 1- get sector details to get the industry ID necessary to fetch the sector list
  // 2- get list of industries + list of sectors for
  [types.SECTOR_FETCH] (state, payload) {
    state.industryOptions = [];
    state.sectorOptions = [];
    state.categoryOptions = [];
    state.bics = [];
    state.showSelected = false;
    state.industryLoading = true;
    state.sectorLoading = true;
    state.categoryLoading = false;
    state.sector = payload.sector;
    state.mode = 'browse';
    state.alternateBic = null;
    state.alternateBicSource = null;
    state.category = null;
  },
  [types.SECTOR_RECEIVED] (state, payload) {
    state.industry = payload.industry;
  },
  [types.INDUSTRIES_SECTORS_CATEGORIES_RECEIVED] (state, payload) {
    state.industryLoading = false;
    state.sectorLoading = false;
    state.industryOptions = payload.industryOptions.slice();
    state.sectorOptions = payload.sectorOptions.slice();
    state.categoryOptions = payload.categoryOptions.slice();
  },
  // browse
  [types.BROWSE_START] (state, payload) {
    state.mode = 'browse';
    state.category = payload.category;
    state.loading = true;
    state.bics = [];
    state.industryLoading = true;
    state.sectorLoading = true;
    state.categoryLoading = true;
  },
  [types.BROWSE_PARAMS_RECEIVED] (state, payload) {
    state.industry = payload.industry;
    state.sector = payload.sector;
    state.category = payload.category;
  },
  [types.BICS_BROWSE_RECEIVED] (state, payload) {
    state.bics = payload.bics.slice(); // create clone of the array, doesn't pass the reference 
    state.loading = false;
    state.industryLoading = false;
    state.sectorLoading = false;
    state.categoryLoading = false;
    state.showSelected = false;
    state.industryOptions = payload.industryOptions.slice();
    state.sectorOptions = payload.sectorOptions.slice();
    state.categoryOptions = payload.categoryOptions.slice();
  },
  // select
  [types.SELECT_START] (state, payload) {
    state.mode = 'select';
    state.bicsSelected = payload.bicsSelected;
    state.loading = true;
    state.bics = [];
  },
  [types.BICS_SELECTED_RECEIVED] (state, payload) {
    state.bics = payload.slice(); // create clone of the array, doesn't pass the reference 
    state.bicsSelected = payload.slice();
    state.loading = false;
    state.showSelected = true;
  },
  [types.BICS_SELECTED_INIT] (state, payload) {
    state.bicsSelected = payload.bicsSelected.slice();
  },
  [types.BIC_ALTERNATE_START] (state, payload) {
    state.alternateBicLoading = true;
    state.alternateBicSource = payload.source_code;
    state.alternateBic = null;
  },
  [types.BIC_ALTERNATE_RECEIVED] (state, payload) {
    state.alternateBic = { ...payload };
    state.alternateBicLoading = false;
  },
  [types.BIC_ALTERNATE_CLEAR] (state) {
    state.alternateBicLoading = false;
    state.alternateBic = null;
    state.alternateBicSource = null;
  },
  [types.API_ERROR] (state, payload) {
    state.bics = [];
    state.loading = false;
    state.messageType = 'error';
    state.message = payload.error;
  },
  [types.API_ERROR] (state, payload) {
    state.bics = [];
    state.loading = false;
    state.messageType = 'error';
    state.message = payload.error;
  },
  [types.ADD_TO_WATCHLIST] (state, payload) {
    if (!(state.bicsSelected.find(item => item.id === payload.id) )) {
      state.bicsSelected.push(dataHelper.clone(payload));
    }
  },
  [types.REMOVE_FROM_WATCHLIST] (state, payload) {
    state.bicsSelected = state.bicsSelected.filter(item => item.id !== payload.id);
    if (!state.bicsSelected.length) {
      state.showSelected = false;
    }
  },
  [types.CLEAR_WATCHLIST] (state) {
    state.bicsSelected = [];
    state.showSelected = false;
  },
  [types.TOGGLE_BICS_HELP] (state, payload) {
    state.bicsHelp = (payload.code !== state.bicsHelp) ? payload.code : null;
  },
  [types.SET_SHOW_SELECTED] (state, payload) {
    if (payload.showSelected === true || payload.showSelected === false) {
      state.showSelected = payload.showSelected;
    }
  },
  [types.SET_DISPLAY_LIST] (state, payload) {
    if (payload.displayList === true || payload.displayList === false) {
      state.displayList = payload.displayList;
    }
  },
}